import * as authService from './auth.jsx';
import { userService } from './userService.jsx';
import { roleService } from './roleService.jsx';
import { employeeService } from './employeeService.jsx';
import { siteService } from './siteService.jsx';
import { deviceService } from './deviceService.jsx';

// Legacy compatibility
export const apiService = {
  auth: authService,
  user: userService,
  role: roleService,
  employee: employeeService,
  site: siteService,
  device: deviceService,
};
